import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'
import { FieldType } from '@wix/wix-data-schema-types'

export const textMarquee: DataBindingComponentModel = {
  panel: {
    height: 212,
    title: 'Connect_Panel_Title_TextMarquee',
    // TODO: add help id
    helpId: '',
  },
  isConnectGfppEnabled: true,
  componentName: 'TextMarquee_db_comp_name',
  sections: [
    {
      role: 'TextMarqueeRole',
      bindings: [
        {
          title: 'Connect_Panel_Connect_TextMarquee_Label',
          prop: 'text',
          supportedFieldTypes: [
            FieldType.text,
            FieldType.number,
            FieldType.dateTime,
            FieldType.time,
            FieldType.url,
            FieldType.address,
            FieldType.richText,
          ],
          defaultFieldType: FieldType.text,
          requiresPrimaryConnection: true,
        },
      ],
      manifest: {
        gfpp: {
          desktop: {
            mainAction1: {
              actionId: 'gfpp_edit_text',
              label: 'TextMarquee_db_edit_text_label',
            },
          },
        },
      },
      manageContentPanel: {
        description: 'TextMarquee_db_manage_content',
      },
    },
  ],
  compactErrorPanel: true,
}
